import { memo, SyntheticEvent, useState } from "react";
import { Button, Tab, TabPane, TabProps } from "semantic-ui-react";

// Components
import CardVitalSign from "react-lib/apps/HISV3/PTM/CardVitalSign";
import CardMeTriage from "react-lib/apps/MEH/CardMeTriage";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { BTN_ACTS, PatientQueueType, PickedState } from "react-lib/apps/MEH/sequence/PatientQueue";

// Styles
import "./CardMeVitalSign.scss";

type CardMeVitalSignProps = {
  //
  runSequence: any;
  setProp: any;
  onEvent: any;
  // data
  PatientQueueSequence?: PatientQueueType;
  // Common
  languageUX: "en" | "th";
  selectedEncounter?: Record<string, any>;
  selectedPatient?: Record<string, any>;
  selectedDivision: Record<string, any>;
  masterData?: Record<string, any[]>;
  masterOptions?: Record<string, any[]>;
  onClose?: (type?: string) => void;
} & Pick<PickedState, "buttonLoadCheck" | "loadingStatus">;

const CardMeVitalSign = (props: CardMeVitalSignProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const panes = [
    {
      menuItem: {
        key: "triage",
        content: (
          <div style={{ alignItems: "center", justifyContent: "center" }}>
            <label>แบบคัดกรองและประวัติสุขภาพ</label>
          </div>
        ),
      },
      render: () => (
        <TabPane style={{ height: "100%" }}>
          <div style={{ margin: "20px" }}>
            <CardMeTriage
              runSequence={props.runSequence}
              setProp={props.setProp}
              onEvent={props.onEvent}
              PatientQueueSequence={props.PatientQueueSequence}
              selectedDivision={props.selectedDivision}
              buttonLoadCheck={props.buttonLoadCheck}
              masterData={props.masterData}
              masterOptions={props.masterOptions}
              languageUX={props.languageUX}
            />
          </div>
        </TabPane>
      ),
    },
    {
      menuItem: {
        key: "vital_sign",
        content: (
          <div style={{ alignItems: "center", justifyContent: "center" }}>
            <label>Vital Sign</label>
          </div>
        ),
      },
      render: () => (
        <TabPane style={{ height: "100%" }}>
          <div style={{ margin: "20px" }}>
            <CardVitalSign
              useUTCTime={true}
              key="vitalSign"
              closeable={false}
              toggleable={false}
              callOnDidMount={false}
              useCheckboxDateManual={true}
              hideFilter={true}
              hideBarChart={true}
              hideLayOut={true}
              styleFooter={{ width: "100%", marginLeft: "0px" }}
              styleCheckedDateFooter={{ minWidth: "max-content" }}
              vitalSignTypeByAge={props.selectedPatient?.age}
              vitalSignTypeByEncounter={props.selectedEncounter?.id}
              buttonLoadCheck={props.buttonLoadCheck}
              setProp={props.setProp}
              onGetLastHeight={() =>
                props.onEvent({
                  message: "GetLastHeight",
                  params: {},
                })
              }
              onGetVitalSignType={() =>
                props.onEvent({
                  message: "GetVitalSignType",
                  params: {},
                })
              }
              onGetVitalSign={(params: any) =>
                props.onEvent({
                  message: "GetVitalSign",
                  params: params,
                })
              }
              onNewMeasurement={(params: any) =>
                props.onEvent({
                  message: "SaveNewMeasurement",
                  params: params,
                })
              }
              onUpdateVitalsignValue={(params: any) =>
                props.onEvent({
                  message: "AddVitalSignValue",
                  params: params,
                })
              }
              onDeleteMeasurement={(delMeasureId: number, params: any) =>
                props.onEvent({
                  message: "CancelMeasurement",
                  params: { measureId: delMeasureId, data: params },
                })
              }
              languageUX={props.languageUX}
            />
          </div>
        </TabPane>
      ),
    },
  ];

  const handleChangeTab = (_e: SyntheticEvent, data: TabProps) => {
    setActiveTabIndex(data.activeIndex as number);
  };

  const handleSaveTriage = () => {
    props.runSequence({
      sequence: "PatientQueue",
      action: "SAVE_TRIAGE",
      callback: (type: string) => {
        props.onClose?.(type);
      },
    });
  };

  return (
    <div className="card-mevitalsign-main disable-height">
      <Tab
        activeIndex={activeTabIndex}
        menu={{ pointing: true, secondary: true }}
        panes={panes}
        onTabChange={handleChangeTab}
      />
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
        <div style={{ margin: "0px 20px" }}>
          <Button
            fluid
            size="small"
            onClick={() => props.onClose?.()}
            style={{ background: "#cccccc", color: "white" }}
          >
            {"ปิดหน้าต่าง"}
          </Button>
        </div>
        <div>
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={handleSaveTriage}
            // data
            paramKey={BTN_ACTS.SAVE_TRIAGE}
            buttonLoadCheck={props.buttonLoadCheck?.[BTN_ACTS.SAVE_TRIAGE]}
            // config
            style={{
              color: "white",
              ...(props.PatientQueueSequence?.triageData?.triageId === null
                ? { background: "var(--primary-theme-color)" }
                : { background: "#e4a210" }),
            }}
            fluid={true}
            size="small"
            title={
              props.PatientQueueSequence?.triageData?.triageId === null
                ? "บันทึก & ไปยังหน้าพิมพ์เอกสารแรกรับ"
                : "บันทึกการแก้ไข"
            }
          />
        </div>
      </div>
    </div>
  );
};

export default memo(CardMeVitalSign);
